import Image from 'next/image';
import React from 'react';
import styles from './design-prototype.module.css';

export default function DesignPrototype() {
  return (
    <div className={styles.root}>
      <h3 className={styles.title}>How to create perfect design?</h3>
      <p className={styles.text}>
        The uniqueness of the product is the most important.
      </p>
      <div className={styles.banner}>
        <Image
          alt="prototype design banner"
          width={1920}
          height={506}
          src="/design/visual/banner-min.jpg"
        />
      </div>
    </div>
  );
}
